import { render, staticRenderFns } from "./SupplierDetails.vue?vue&type=template&id=ead636ca&scoped=true"
import script from "./SupplierDetails.vue?vue&type=script&lang=js"
export * from "./SupplierDetails.vue?vue&type=script&lang=js"
import style0 from "./SupplierDetails.vue?vue&type=style&index=0&id=ead636ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ead636ca",
  null
  
)

export default component.exports